<form [formGroup]="form" (ngSubmit)="onSubmit()">

  <div class="d-flex justify-content-between toggle-area">
    <div class="col-auto" i18n="@@bankDetailsForm.withIban">My country does not support IBAN</div>
    <div class="col-auto">
      <mat-slide-toggle (change)="switchIban()" [checked]="!withIban" value="false"></mat-slide-toggle>
    </div>
  </div>

  <div *ngIf="error" class="alert alert-warning">
    {{error}}
  </div>  

  <form-field label="Bank Name" i18n-label="@@bankDetailsForm.bankName.label">
    <input type="text" formControlName="bankName" placeholder="Enter bank name" i18n-placeholder="@@bankDetailsForm.bankName.placeholder">
  </form-field>

  <form-field label="Branch Name" i18n-label="@@bankDetailsForm.branchAddress.label">
    <input type="text" formControlName="branchName" placeholder="Enter bank branch name" i18n-placeholder="@@bankDetailsForm.branchAddress.placeholder">
  </form-field>

  <form-field label="Address" i18n-label="@@bankDetailsForm.address.label">
    <input type="text" formControlName="branchAddress" placeholder="Enter bank branch address" i18n-placeholder="@@bankDetailsForm.address.placeholder">
  </form-field>

  <form-field label="SWIFT" i18n-label="@@bankDetailsForm.swift.label">
    <input type="text" formControlName="swiftCode" placeholder="Enter SWIFT code" i18n-placeholder="@@bankDetailsForm.swift.placeholder">
  </form-field>

  <form-field *ngIf="withIban" label="IBAN" i18n-label="@@bankDetailsForm.iban.label">
    <input type="text" formControlName="iban" placeholder="Enter IBAN" i18n-placeholder="@@bankDetailsForm.iban.placeholder">
  </form-field>

  <form-field label="Account number" i18n-label="@@bankDetailsForm.accountNumber.label">
    <input type="text" formControlName="accountNumber" placeholder="Enter Account number" i18n-placeholder="@@bankDetailsForm.accountNumber.placeholder">
  </form-field>

  <form-field label="Account Holder Name" i18n-label="@@bankDetailsForm.bankName.accountHolderLegalName">
    <input type="text" formControlName="accountHolderLegalName" placeholder="Enter full legal account holder name" i18n-placeholder="@@bankDetailsForm.accountHolderLegalName.placeholder">
  </form-field>

  <div class="w-100 d-flex flex-column align-items-center">
    <button type="submit" class="btn btn-block btn-primary" [disabled]="!form.valid">
      <ng-container i18n="@@bankDetailsForm.bankName.submitButton">Save Bank Details</ng-container>
    </button>
  </div>
</form>
